import { Button, Input, Modal, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { ApiCode, Currency } from '../../../../data/common';
import Api from '../../../../utils/Api';
import { GlobalUtil } from '../../../../utils/GlobalText';
import { StyleUtils } from '../../../../utils/Style';
import { AntdButton, AntdInput } from '../../../../views/commonview';
import { formatStr } from '../../../../utils/Utils';
import "../account/index.css"

const ChangePayoutThresholdView = (account: string, defaultPayoutThreshold: string, selectCurrency: Currency, show: boolean, onClick: (ok: boolean) => void) => {
    let [amount, setAmount] = useState(defaultPayoutThreshold)
    let [loading, setLoading] = useState(false)
    const [messageApi, contextHolder] = message.useMessage();
    const clear = () => {
        setAmount("0")
        defaultPayoutThreshold = "0"
    }
    useEffect(() => {
        setAmount(defaultPayoutThreshold);
    }, [defaultPayoutThreshold, amount]);

    const isInvalidPayoutThreshold = (value: string) => {
        return (Number(value) < (selectCurrency?.minPayoutThreshold | 0) || Number(value) > (selectCurrency?.payoutThreshold | 100))
    }

    return <Modal
        className='small_modal'
        open={show}
        centered
        onCancel={() => {
            onClick(false)
            clear()
        }}
        title={GlobalUtil.t("account.editPayoutThreshold")}
        footer={[
            <AntdButton>
                <Button
                    key="payoutThreshold"
                    type="primary"
                    disabled={isInvalidPayoutThreshold(amount)}
                    loading={loading}
                    onClick={async () => {
                        setLoading(true)
                        try {
                            let res = await Api.updatePayoutThreshold(account, selectCurrency.code, Number(amount))
                            if (res.code === ApiCode.SUCCESS) {
                                onClick(true)
                                clear()
                            } else {
                                messageApi.error(res.msg ?? "")
                            }
                        } catch (e) {
                            messageApi.error(GlobalUtil.t("errorTip"))
                        }
                        setLoading(false)
                    }}
                    style={{ width: "100%" }}
                >
                    {GlobalUtil.t("confirm")}
                </Button>
            </AntdButton>
        ]}
    >
        {contextHolder}
        <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ marginTop: StyleUtils.getHeight(15), color: StyleUtils.theme().fontColor_1 }}>{formatStr(GlobalUtil.t("account.modify_account_payout_threshold"), account)}</div>
            { isInvalidPayoutThreshold(amount)  &&
                <div style={{ fontSize: 12, color: "red", }}>{formatStr(GlobalUtil.t("account.inputPayoutThresholdTip"), selectCurrency?.minPayoutThreshold | 0, selectCurrency?.payoutThreshold | 100)}</div>
            }
            <AntdInput>
                <Input
                    style={{ marginTop: StyleUtils.getHeight(5) }}
                    allowClear
                    value={amount}
                    onChange={(e) => {
                        setAmount(e.target.value.trim())
                    }}
                    placeholder={GlobalUtil.t("account.inputPayoutThreshold")}
                />
            </AntdInput>
            <div style={{ marginTop: StyleUtils.getHeight(2), color: StyleUtils.theme().fontColor_1 }}>{formatStr(GlobalUtil.t("account.inputPayoutThresholdTip"), selectCurrency?.minPayoutThreshold | 0, selectCurrency?.payoutThreshold | 100)}</div>
        </div>
    </Modal>



}

export default ChangePayoutThresholdView;